// src/services/adminServices.js
import { authAxiosInstance } from "../utils/axiosinstance";

// ---- Users ----
export const adminGetUsers = ({ userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.get('/api/v1/admin/users/');
};

export const adminUpdateUser = (userId, data, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.put(`/api/v1/admin/users/${userId}/`, data);
};

export const adminDeleteUser = (userId, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.delete(`/api/v1/admin/users/${userId}/delete/`);
};

// ---- Products ----
export const adminGetProducts = ({ userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.get('/api/v1/admin/products/');
};

export const adminCreateProduct = (productData, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.post('/api/v1/admin/products/create/', productData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const adminUpdateProduct = (productId, data, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.put(`/api/v1/admin/products/${productId}/update/`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const adminDeleteProduct = (productId, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.delete(`/api/v1/admin/products/${productId}/delete/`);
};

// ---- Orders ----
export const adminGetOrders = ({ userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.get('/api/v1/admin/orders/');
};

export const adminUpdateOrder = (orderId, data, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.put(`/api/v1/admin/orders/${orderId}/update/`, data);
};

export const adminDeleteOrder = (orderId, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.delete(`/api/v1/admin/orders/${orderId}/delete/`);
};

// ---- Colors ----
export const adminCreateColor = (data, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.post('/api/v1/admin/colors/create/', data);
};

export const adminDeleteColor = (colorId, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.delete(`/api/v1/admin/colors/${colorId}/delete/`);
};